/**
 * Times are shown in Zurich on a 24-hour clock, whoever is looking and wherever they
 * are. An experiment's telemetry is read alongside the team's own logs and calendars,
 * so a fixed zone is what makes two people talking about "16:20" mean the same
 * instant; the browser's own locale would make that accidental.
 */
export const RUN_ZONE = 'Europe/Zurich'
const CLOCK = 'de-CH'

/** "16:20" */
export const fmtTime = (iso?: string | null) => iso
  ? new Date(iso).toLocaleTimeString(CLOCK, { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: RUN_ZONE })
  : ''
/** "18 Sep" */
export const fmtShortDay = (iso?: string | null) => iso
  ? new Date(iso).toLocaleDateString(CLOCK, { day: '2-digit', month: 'short', timeZone: RUN_ZONE })
  : ''
/** "18.09.2026, 16:20" */
export const fmtDateTime = (iso?: string | null) => iso
  ? new Date(iso).toLocaleString(CLOCK, { dateStyle: 'short', timeStyle: 'short', hour12: false, timeZone: RUN_ZONE })
  : ''

export const fmtDate = (iso?: string | null) =>
  iso ? new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : ''

export const fmtDay = (iso?: string | null) => (iso ? new Date(iso).toLocaleDateString(undefined, { dateStyle: 'medium' }) : '')

/** "today", "yesterday", "3 days ago" or the date for anything older than a week. */
export function fmtAgo(iso?: string | null): string {
  if (!iso) return ''
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86_400_000)
  if (days <= 0) return 'today'
  if (days === 1) return 'yesterday'
  if (days < 7) return `${days} days ago`
  return fmtDay(iso)
}

export function fmtBytes(n?: number | null): string {
  if (!n) return ''
  const units = ['B', 'KB', 'MB', 'GB']
  let i = 0
  let v = n
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++ }
  return `${v.toFixed(i === 0 ? 0 : 1)} ${units[i]}`
}

export const KIND_LABEL: Record<string, string> = {
  video: 'Screen recording',
  initial_state: 'Initial state',
  model_results: 'Model outputs and scores',
  state: 'Backend state tracking',
  example_positive: 'Positive example',
  example_negative: 'Negative example',
  attachment: 'Attachment',
}
